import { initStatusWidget } from "./utils/statusWidget";

(function (name, context, definition, version) {
    "use strict";
    if (typeof window.define === "function" && window.define.amd) {
        window.define(definition);
    } else if (typeof module !== "undefined" && module.exports) {
        module.exports = definition(version);
    } else if (context.exports) {
        context.exports = definition(version);
    } else {
        context[name] = definition(version);
    }
})(
    "cemtrikStatus",
    typeof globalThis !== "undefined" ? globalThis : this,
    function () {
        initStatusWidget();
        return {
            initStatusWidget,
        };
    },
    "1.0.0",
);
if (document.readyState === "complete") {
    initStatusWidget();
}
window.initStatusWidget = initStatusWidget;
